const cols = [
  ["FundTap Quote Id", "FTQuoteID"],
  ["Status", "status"],
  ["Xero Status", "xeroStatus"],
  ["Invoice Number", "invoiceNumber"],
  ["Date Funded", "dateFunded"],
  ["Customer", "customer"],
  ["Debtor", "debtor"],
  ["Inv Funded", "invFunded"],
  ["Fee Today", "feeToday"],
  ["Amount Due", "amountDue"],
  ["Due Date", "dueDate"],
  ["Date In", "dueIn"],
  ["Date Completed", "dateCompleted"]
];

export const COLUMNS = cols.map(([Header, accessor]) => ({ Header, accessor }));
